// test1825
(1825 && 0);
